import React from "react";
import { FaCheck, FaTimes } from "react-icons/fa";

const DuplicateCodesModal = ({ isOpen, codes = [], onAccept, onIgnore }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg  overflow-y-auto p-6 relative border border-gray-200">
        <h2 className="text-xl font-semibold mb-5 text-gray-800">
          ⚠️ Duplicate Voucher Codes Found
        </h2>

        {codes.length === 0 ? (
          <p className="text-gray-500 text-sm">No duplicate codes available.</p>
        ) : (
          <ul className="overflow-y-auto max-h-60 pr-2 divide-y divide-gray-200 border border-gray-300 rounded-md mb-6">
            {codes.map((code, index) => (
              <li
                key={index}
                className="px-4 py-2 text-sm text-gray-700 bg-gray-50 even:bg-white"
              >
                {index + 1}. {code}
              </li>
            ))}
          </ul>
        )}

        <div className="sticky bottom-0 bg-white flex justify-end gap-3 pt-3 border-t border-gray-200">
          <button
            onClick={onIgnore}
            className="flex items-center gap-2 bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 transition"
          >
            <FaTimes size={14} />
            Ignore
          </button>
          <button
            onClick={onAccept}
            className="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition"
          >
            <FaCheck size={14} />
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default DuplicateCodesModal;
